import {
  Component,
  OnDestroy,
  OnInit,
  Inject,
  EventEmitter,
  PLATFORM_ID,
  Renderer2,
  Output,
  ViewChild,
} from "@angular/core";
import {
  AppLayoutComponent,
  MainNavComponent,
  DataService,
  FgAppConstants,
  FG_APP_CONSTANTS,
  AppSettings,
  DeviceHelper,
  UserService,
  ThemingService,
  FgMenuService,
  LocalStorageService,
} from "fg-library";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { BreakpointObserver } from "@angular/cdk/layout";
import { ActivatedRoute, Router } from "@angular/router";
import { ClientConfigurations } from "src/app/environment-configuration";
import { isPlatformBrowser } from "@angular/common";
import { LayoutService } from "./layoutservice";
import { MatSidenav } from "@angular/material/sidenav";

@Component({
  selector: "fg-client-app-main-nav",
  templateUrl: "./main-nav.component.html",
  styleUrls: ["./main-nav.component.scss"],
  standalone: false,
})

export class FgClientMainNavComponent extends MainNavComponent implements OnInit, OnDestroy {
  @ViewChild('drawer') drawer!: MatSidenav;
  isBrowser: boolean = false;
  @Output() settingsClicked = new EventEmitter<void>();
  activeSection: "apps" | "tools" = "apps";
  mlevel = 2;
  showDefaultSideNav = false;
  AppPreference: any = { layout: 'HORIZONTAL', theme: 'fingress-blue' };
  items: SidebarItem[] = [
    {
      label: "Dashboard",
      icon: "dashboard",
      route: "/dashboard",
    },
    {
      label: "Apps",
      icon: "apps",
      children: [
        { label: "Calendar", icon: "calendar_today", route: "/calendar" },
        { label: "Email", icon: "email", route: "/email" },
      ],
    },
    {
      label: "Settings",
      icon: "settings",
      children: [
        { label: "Profile", route: "/settings/profile" },
        { label: "Billing", route: "/settings/billing" },
      ],
    },
  ];

  constructor(
    public breakpointObserver: BreakpointObserver,
    public fgMenuService: FgMenuService,
    public dataService: DataService,
    public router: Router,
    public route: ActivatedRoute,
    @Inject(FG_APP_CONSTANTS) public fgAppConstant: FgAppConstants,
    public userService: UserService,
    public themingService: ThemingService,
    private localStorage: LocalStorageService,
    private renderer: Renderer2,
    private layoutService: LayoutService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    super(
      breakpointObserver,
      fgMenuService,
      dataService,
      router,
      route,
      new ClientConfigurations()
    );
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.layoutService.layout$.subscribe((layout) => {
      this.setLayout(layout);
    });

    this.sideNav.openedStart.subscribe(() => (this.isOpened = true));
    this.sideNav.openedChange.subscribe((res) => (this.isOpened = res));
    this.toggleSideMenu$.subscribe((res) => (this.toggleSideMenu = res));

    this.fgMenuService.fgSideNav.subscribe((sidebarStatus) => {
      this.toggleSideBar(sidebarStatus);
    });

    this.initializeHeadlessConfig();
    this.getApps();
    this.showMobileTopNav = DeviceHelper.isMobile();

    if (this.isBrowser) {
      this.AppPreference = JSON.parse(this.localStorage.get("AppPreference"));
      if (!this.AppPreference) {
        this.AppPreference = {
          theme: 'tradeportal-theme',
          layout: 'HORIZONTAL'
        };
      }

      const existingTheme = this.AppPreference.theme;
      this.AppPreference.layout = this.AppPreference.layout || "HORIZONTAL";
      this.renderer.addClass(document.body, existingTheme);
      this.localConfig.currentLogo = existingTheme === "dark-theme"
        ? "assets/img/logo_white.png"
        : "assets/img/logo.png";

      this.localConfig.currentTheme = existingTheme;
      this.themingService.theme = existingTheme;
      this.themingService.set(JSON.stringify(existingTheme));

      const root = document.documentElement;
      let currentSkin: any;
      this.localStorage.set('AppPreference', JSON.stringify(this.AppPreference));
      for (const key in currentSkin) {
        root.style.removeProperty(key);
        root.style.setProperty(key, currentSkin[key]);
      }

      this.setLayout(this.AppPreference.layout);
    }

    if (this.fgMenuService.currentApplicationMenus) {
      this.menus = this.fgMenuService.currentApplicationMenus;
    }
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    this.toggleSideBar(false);

    if (this.fgMenuService.fgCurrentApplication?.uuid) {
      this.getCurrentAppConfig();
    }
  }

  getCurrentAppConfig() {
    this.appConfig = (this.fgAppConstant as any)["AppUtills"].parseJSON(
      this.fgMenuService.fgCurrentApplication.navigationSchema
    );

    if (DeviceHelper.isMobile()) {
      this.hideSidenav = false;
    }

    if (!DeviceHelper.isMobile() && (this.appConfig?.isVertical || this.AppPreference.layout === 'VERTICAL')) {
      this.localConfig.isVerticalMenu = true;
      this.hideSidenav = false;
      this.fgMenuService.toggleSideNav(true);
    } else {
      this.localConfig.isVerticalMenu = false;
      this.fgMenuService.toggleSideNav(false);
    }
  }

  goToLandingPage(): string {
    if (this.userService.currentUserValue?.b2cAccessMode == "standalone") {
      return '';
    }

    const studioUtils = (this.fgAppConstant as any)["StudioUtills"];
    const appUtills = (this.fgAppConstant as any)["AppUtills"];
    let pageId = "";
    let defaultAppId = "";

    if (
      this.fgMenuService.appId == "4063b97b-f531-44e4-a880-5c597913d106" ||
      this.fgMenuService.appId == "c9a63bba-ec5e-441f-bd16-0c6796b777a6" ||
      this.fgMenuService.appId == "c258cf16-bb12-43cb-af3c-437eec62b0cc"
    ) {
      pageId = "67b8c8b5-474e-4a58-b37a-dc0829ed018b";
      defaultAppId = "4063b97b-f531-44e4-a880-5c597913d106";
    } else if (
      this.fgMenuService.appId == "ef45930c-cdd5-478e-80c1-f621736f393b" ||
      this.fgMenuService.appId == "95d25831-1e24-46f4-bc99-3ebeff7a16be"
    ) {
      pageId = "0c760f0b-3033-4d63-afb9-712ea5910ece";
      defaultAppId = "ef45930c-cdd5-478e-80c1-f621736f393b";
    }

    if (pageId) {
      let pageUrl = studioUtils.getFormUrl(this.router.url) + pageId + "/" + defaultAppId;
      if (appUtills.isNotNull(studioUtils.getNamedPageUrl(pageId))) {
        pageUrl = studioUtils.getNamedPageUrl(pageId);
      }
      return pageUrl;
    }

    return '';
  }


  setLayout(layout: string) {
    this.AppPreference.layout = layout;
    if (layout === 'VERTICAL') {
      this.localConfig.isVerticalMenu = true;
      this.hideSidenav = false;
      setTimeout(() => {
        this.drawer?.open();
        this.fgMenuService.toggleSideNav(true);
      }, 150);
    } else {
      this.localConfig.isVerticalMenu = false;
      if (!DeviceHelper.isMobile()) {
        this.drawer?.close();
        this.fgMenuService.toggleSideNav(false);
      }
    }
  }

  onToggleMenu(drawer: any): void {
    if (this.userService.currentUserValue?.b2cAccessMode != "standalone" ||
      this.fgMenuService.appId == "c9a63bba-ec5e-441f-bd16-0c6796b777a6") {
      drawer.toggle();
    }
  }

  openSettingsDrawer() {
    this.settingsClicked.emit();
  }

  toggle(item: SidebarItem) {
    item["expanded"] = !item["expanded"];
  }
}

export interface SidebarItem {
  label: string;
  icon?: string;
  route?: string;
  children?: SidebarItem[];
}